import Block from "components/layout/Block";
import { useTranslation } from "react-i18next";
import styled, { css } from "styled-components";

const StyledNoResultWrapper = styled(Block)`
	margin: 0.5rem 0 0.5rem 0;
	padding: 0.5rem 1rem;
	user-select: none;
	cursor: pointer;

	${({ $isLanding }) =>
		$isLanding &&
		css`
			font-size: 1.1rem;
		`}

	color: ${({ theme: { colors }, $alwaysLight }) =>
		$alwaysLight ? colors.blackAlways : colors.black};

	&:hover {
		background-color: ${({ theme: { colors }, $alwaysLight }) =>
			$alwaysLight
				? colors.menuItemHoverAlwaysLight
				: colors.menuItemHover};
	}
`;

export const NoResultItem = ({
	isLanding = false,
	alwaysLight = false,
	onClick,
	isOpen,
	searchInputRef,
}) => {
	const { t } = useTranslation(["common"]);
	return (
		<StyledNoResultWrapper
			$isLanding={isLanding}
			$alwaysLight={alwaysLight}
			onClick={() => {
				if (typeof onClick === "function") {
					onClick();
				}
				if (isOpen && searchInputRef.current) {
					searchInputRef.current.focus({ preventScroll: true });
				}
			}}
		>
			{t("common:errors.noResults")}
		</StyledNoResultWrapper>
	);
};
